(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-selector-v2"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var root = document.getElementById('bundleSelectorV2');
  if (!root) return;

  /* ── DOM refs ── */
  var cards       = root.querySelectorAll('.bsv2__card');
  var subCheck    = document.getElementById('bsv2SubCheck');
  var subNote     = document.getElementById('bsv2SubNote');
  var subDays     = document.getElementById('bsv2SubDays');
  var atcBtn      = document.getElementById('bsv2ATC');
  var atcPrice    = document.getElementById('bsv2ATCPrice');
  var atcSpinner  = document.getElementById('bsv2ATCSpinner');
  var atcText     = root.querySelector('.bsv2__atc-text');
  var gifts       = root.querySelectorAll('.bsv2__gift');
  var giftCount   = document.getElementById('bsv2GiftCount');
  var giftUpgrade = document.getElementById('bsv2GiftUpgrade');
  var colorsInner = document.getElementById('bsv2ColorsInner');

  /* ── Data from Liquid ── */
  var variantId      = parseInt(root.dataset.variantId, 10);
  var giftPowderId   = parseInt(root.dataset.giftPowderId, 10);
  var giftStickId    = parseInt(root.dataset.giftStickId, 10);
  var sellingPlan30  = root.dataset.sellingPlan30 ? parseInt(root.dataset.sellingPlan30, 10) : 0;
  var sellingPlan60  = root.dataset.sellingPlan60 ? parseInt(root.dataset.sellingPlan60, 10) : 0;
  var sellingPlan90  = root.dataset.sellingPlan90 ? parseInt(root.dataset.sellingPlan90, 10) : 0;
  var colorOptions   = root.dataset.colorOptions ? root.dataset.colorOptions.split('|||') : [];
  var hasColors      = colorOptions.length > 0 && colorOptions[0] !== '';

  var productVariants = [];
  try {
    productVariants = JSON.parse(root.dataset.productVariants || '[]');
  } catch(e) {}

  var priceData = {
    otPer:   [0, parseInt(root.dataset.otPer1), parseInt(root.dataset.otPer2), parseInt(root.dataset.otPer3)],
    otTotal: [0, parseInt(root.dataset.otTotal1), parseInt(root.dataset.otTotal2), parseInt(root.dataset.otTotal3)],
    subPer:  [0, parseInt(root.dataset.subPer1), parseInt(root.dataset.subPer2), parseInt(root.dataset.subPer3)],
    subTotal:[0, parseInt(root.dataset.subTotal1), parseInt(root.dataset.subTotal2), parseInt(root.dataset.subTotal3)],
    cmpPer:  parseInt(root.dataset.cmpPer),
    cmpTotal:[0, parseInt(root.dataset.cmpTotal1), parseInt(root.dataset.cmpTotal2), parseInt(root.dataset.cmpTotal3)]
  };

  /* Delivery days per tier */
  var deliveryDays = { 1: 30, 2: 60, 3: 90 };

  /* Selling plan per tier */
  var sellingPlanByTier = {
    1: sellingPlan30,
    2: sellingPlan60,
    3: sellingPlan90
  };

  /* ── State ── */
  var state = {
    tier: 2,
    subscribed: false,
    colors: {} /* { 'bottle_1': 'Black', 'bottle_2': 'Dark Brown' } */
  };

  /* ── Helpers ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariantByColor(color) {
    for (var i = 0; i < productVariants.length; i++) {
      var v = productVariants[i];
      if (v.option1 === color || v.option2 === color || v.option3 === color) {
        if (v.available) return v;
      }
    }
    /* Fallback: return even if unavailable */
    for (var j = 0; j < productVariants.length; j++) {
      var v2 = productVariants[j];
      if (v2.option1 === color || v2.option2 === color || v2.option3 === color) {
        return v2;
      }
    }
    return null;
  }

  /* ── Build color selectors ── */
  function buildColorSelectors() {
    if (!hasColors || !colorsInner) return;

    var tier = state.tier;
    colorsInner.innerHTML = '';

    if (tier === 1) {
      /* Tier 1: single color dropdown */
      var row = createColorRow('Colour', 'bottle_1');
      colorsInner.appendChild(row);
    } else {
      /* Tier 2+: one dropdown per bottle */
      for (var i = 1; i <= tier; i++) {
        var label = 'Bottle ' + i + ' Colour';
        var key = 'bottle_' + i;
        var row2 = createColorRow(label, key);
        colorsInner.appendChild(row2);
      }
    }
  }

  function createColorRow(labelText, stateKey) {
    var row = document.createElement('div');
    row.className = 'bsv2__color-row';

    var label = document.createElement('label');
    label.textContent = labelText;
    row.appendChild(label);

    var select = document.createElement('select');
    select.className = 'bsv2__color-select';

    for (var i = 0; i < colorOptions.length; i++) {
      var opt = document.createElement('option');
      opt.value = colorOptions[i];
      opt.textContent = colorOptions[i];
      if (state.colors[stateKey] === colorOptions[i]) {
        opt.selected = true;
      }
      select.appendChild(opt);
    }

    /* Set default if not yet set */
    if (!state.colors[stateKey]) {
      state.colors[stateKey] = colorOptions[0];
    }

    select.addEventListener('change', function() {
      state.colors[stateKey] = select.value;
    });

    row.appendChild(select);
    return row;
  }

  /* ── Render ── */
  function render() {
    var isSub = state.subscribed;
    var tier  = state.tier;

    /* Cards — show per-bottle price */
    cards.forEach(function(card) {
      var t = parseInt(card.dataset.tier, 10);
      var perPrice = isSub ? priceData.subPer[t] : priceData.otPer[t];
      var cmpPrice = priceData.cmpPer;

      card.classList.toggle('bsv2__card--selected', t === tier);

      var priceEl   = card.querySelector('[data-price]');
      var compareEl = card.querySelector('[data-compare]');
      var savingsEl = card.querySelector('[data-savings]');

      if (priceEl) priceEl.textContent = formatMoney(perPrice);
      if (compareEl) {
        compareEl.textContent = formatMoney(cmpPrice);
        /* Hide compare if same as price */
        compareEl.style.display = (cmpPrice > perPrice) ? '' : 'none';
      }

      /* Calculate savings % vs compare_at_price */
      if (savingsEl) {
        if (cmpPrice > perPrice) {
          var pct = Math.round((1 - perPrice / cmpPrice) * 100);
          savingsEl.textContent = 'Save ' + pct + '%';
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }
    });

    /* Subscribe note */
    if (subNote) {
      subNote.style.display = isSub ? '' : 'none';
    }
    if (subDays) {
      subDays.textContent = deliveryDays[tier] || 30;
    }

    /* Gifts — based on TIER only (not subscription) */
    var unlocked = 0;
    gifts.forEach(function(gift) {
      var unlockTier = parseInt(gift.dataset.unlockTier, 10);
      var isUnlocked = tier >= unlockTier;

      gift.classList.toggle('bsv2__gift--unlocked', isUnlocked);
      gift.classList.toggle('bsv2__gift--locked', !isUnlocked);
      if (isUnlocked) unlocked++;
    });

    if (giftCount) giftCount.textContent = unlocked;
    if (giftUpgrade) {
      giftUpgrade.style.display = unlocked >= 3 ? 'none' : '';
    }

    /* ATC price — show total */
    var cartPrice = isSub ? priceData.subTotal[tier] : priceData.otTotal[tier];
    if (atcPrice) atcPrice.textContent = formatMoney(cartPrice);

    /* Color selectors */
    buildColorSelectors();
  }

  /* ── Events: Tier selection ── */
  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      state.tier = parseInt(card.dataset.tier, 10);
      render();
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        state.tier = parseInt(card.dataset.tier, 10);
        render();
      }
    });
  });

  /* ── Events: Subscribe toggle ── */
  if (subCheck) {
    subCheck.addEventListener('change', function() {
      state.subscribed = subCheck.checked;
      render();
    });
  }

  /* ── Events: Upgrade link (select tier 3) ── */
  if (giftUpgrade) {
    giftUpgrade.addEventListener('click', function() {
      state.tier = 3;
      render();
      var tiersEl = document.getElementById('bsv2Tiers');
      if (tiersEl) tiersEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  /* ── Add to Cart ── */
  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      if (atcBtn.disabled) return;
      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding...';
      if (atcSpinner) atcSpinner.style.display = '';

      var tier = state.tier;
      var qty  = parseInt(cards[tier - 1].dataset.qty, 10);
      var isSub = state.subscribed;
      var sellingPlan = isSub ? (sellingPlanByTier[tier] || 0) : 0;

      var items = [];

      if (hasColors && tier > 1) {
        /* Multiple bottles — each may have different color */
        for (var b = 1; b <= qty; b++) {
          var colorKey = 'bottle_' + b;
          var color = state.colors[colorKey] || colorOptions[0];
          var variant = findVariantByColor(color);
          var vid = variant ? variant.id : variantId;

          var item = {
            id: vid,
            quantity: 1,
            properties: { '_bundle_tier': tier.toString(), '_bundle_bottle': b.toString() }
          };
          if (sellingPlan) {
            item.selling_plan = sellingPlan;
          }
          items.push(item);
        }
      } else if (hasColors && tier === 1) {
        /* Single bottle with color */
        var color1 = state.colors['bottle_1'] || colorOptions[0];
        var variant1 = findVariantByColor(color1);
        var vid1 = variant1 ? variant1.id : variantId;

        var mainItem = {
          id: vid1,
          quantity: 1,
          properties: { '_bundle_tier': '1' }
        };
        if (sellingPlan) {
          mainItem.selling_plan = sellingPlan;
        }
        items.push(mainItem);
      } else {
        /* No color options — single line item */
        var mainItemNoColor = {
          id: variantId,
          quantity: qty,
          properties: { '_bundle_tier': tier.toString() }
        };
        if (sellingPlan) {
          mainItemNoColor.selling_plan = sellingPlan;
        }
        items.push(mainItemNoColor);
      }

      /* Gift items — based on tier (not subscription) */
      /* Gift 1: Powder — tier 2+ */
      if (tier >= 2 && giftPowderId) {
        items.push({
          id: giftPowderId,
          quantity: 1,
          properties: { '_bundle_gift': 'true', '_bundle_tier': tier.toString() }
        });
      }
      /* Gift 2: Stick — tier 3 only */
      if (tier >= 3 && giftStickId) {
        items.push({
          id: giftStickId,
          quantity: 1,
          properties: { '_bundle_gift': 'true', '_bundle_tier': tier.toString() }
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function() {
        if (atcText) atcText.textContent = 'Added!';
        setTimeout(function() {
          window.location.href = '/cart';
        }, 600);
      })
      .catch(function(err) {
        console.error('ATC error:', err);
        if (atcText) atcText.textContent = 'Error — Try Again';
        atcBtn.disabled = false;
        if (atcSpinner) atcSpinner.style.display = 'none';
        setTimeout(function() {
          if (atcText) atcText.textContent = 'ADD TO CART';
        }, 2500);
      });
    });
  }

  /* ── Initial render ── */
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
